var React = require('react');
var { connect } = require('react-redux');
var fieldManager = require('fieldManager');
var distributionActions = require('distributionActions');
var NextActionsContainer = require('NextActionsContainer');
var ExtendedFieldDetails = require('ExtendedFieldDetails');
var FieldDetailsWPGraph = require('./AllFarmView/FieldDetailsWPGraph.jsx');
var WaterMeterGraphContainer = require('WaterMeterGraphContainer');
var SoilTemperatureGraphContainer = require('SoilTemperatureGraphContainer');
var MapContainer = require('MapContainer');
var FieldsDropdown = require('FieldsDropdown');
var authenticateActions = require('authenticateActions');
var { withTranslation } = require('react-i18next');
var { Link } = require('react-router-dom');
var ArchiveFieldIcon = require('images/icons/dashboard_states/archive_field_icon.svg');
const RecommendationTileWrapper = require('../planning/IrrigationRecommendation/RecommendationTileWrapper');
const {
  isSupportingPlannerByWeeks,
  shouldDisplaySoilTemperatureGraph,
} = require('@managers/fieldManager');
var {
  get_configuration_config,
  FeatureFlagDictionary,
} = require('remoteConfigurationsManager');
const {
  graphSectionEvent,
  buildGraphToggleIcons,
} = require('./graphSectionHelpers');
require('./dashboardNextActionsContainerGraphOnly.css');

class DashboardContent extends React.Component {
  constructor(props) {
    super(props);

    this.onLogoutButtonClick = this.onLogoutButtonClick.bind(this);
    this.paintArrow = this.paintArrow.bind(this);
    this.onToggleClick = this.onToggleClick.bind(this);
    this.state = {
      selectedSection: 'drop',
      firstTimeInit: true,
    };
  }

  componentDidMount() {}

  onToggleClick(toggle) {
    mixpanel.track(graphSectionEvent(toggle));
    this.setState({ selectedSection: toggle });
  }

  paintArrow(canvasElement) {
    if (canvasElement) {
      var ctx = canvasElement.getContext('2d');
      ctx.lineWidth = 13;
      ctx.lineJoin = 'miter';
      ctx.miterLimit = 1;
      ctx.strokeStyle = '#919DB4';
      ctx.moveTo(0, ctx.canvas.height);
      ctx.lineTo(ctx.canvas.width / 2.0, 0);
      ctx.lineTo(ctx.canvas.width, ctx.canvas.height);
      ctx.stroke();
    }
  }

  graphSwitch(toggleIcons) {
    const { temperatureUnit } = this.props;
    if (this.state.selectedSection == 'drop') {
      // Use the Farm-View water-potential graph here too (chip-based
      // date filter, sensor chip legend, unified rounded card with the
      // event tray). The drop / accumulated / temperature toggle is
      // forwarded into the title row via the `onToggleClick` /
      // `toggleIcons` / `temperatureUnit` props (the Farm View Field
      // details tab passes them too, with its "Graphs" layout).
      return (
        <FieldDetailsWPGraph
          onToggleClick={this.onToggleClick}
          toggleIcons={toggleIcons}
          temperatureUnit={temperatureUnit}
          fluidHeight
        />
      );
    }
    if (this.state.selectedSection == 'accumulated') {
      return (
        <WaterMeterGraphContainer
          onToggleClick={this.onToggleClick}
          icon={toggleIcons}
          temperatureUnit={temperatureUnit}
        />
      );
    }
    if (this.state.selectedSection == 'temperature') {
      return (
        <SoilTemperatureGraphContainer
          onToggleClick={this.onToggleClick}
          icon={toggleIcons}
          temperatureUnit={temperatureUnit}
        />
      );
    }
  }

  componentDidUpdate(previousProps, previousState) {
    var arrowNitrogen = document.getElementById('arrowNitrogen');
    var arrowWater = document.getElementById('arrowWater');
    this.paintArrow(arrowNitrogen);
    this.paintArrow(arrowWater);
    var graphToDisplay = fieldManager.dashboardGraphToDisplay(
      this.props.selectedField,
    );

    if (
      previousProps.selectedField?.id !== this.props.selectedField?.id &&
      !this.state.firstTimeInit
    ) {
      this.setState({ selectedSection: graphToDisplay, firstTimeInit: true });
    } else if (
      previousProps.selectedField?.id === this.props.selectedField?.id &&
      this.state.firstTimeInit
    ) {
      this.setState({
        selectedSection: graphToDisplay,
        firstTimeInit: false,
      });
    }
  }

  componentWillUnmount() {}

  onLogoutButtonClick() {
    this.props.logout();
  }

  render() {
    const { t } = this.props;
    let fieldHasPlan = fieldManager.isSupportingPlannerByDays(
      this.props.selectedField,
    );
    var shouldDisplayAccumulatedIrr =
      fieldManager.shouldDisplayAccumulatedIrrigation(this.props.selectedField);

    // Check if temperature graph should be displayed
    const temperatureGraphFeatureFlag = get_configuration_config(
      this.props.configuration_data,
      FeatureFlagDictionary.TEMPERATURE_GRAPH,
      this.props.selectedFarmingUnit?.name,
      this.props.selectedDistribution?.name,
    );
    const fieldHasSoilTempData = shouldDisplaySoilTemperatureGraph(
      this.props.selectedField,
    );
    const toggleIcons = buildGraphToggleIcons({
      showAccumulated: shouldDisplayAccumulatedIrr,
      temperatureFlag: temperatureGraphFeatureFlag,
      hasSoilTemperatureData: fieldHasSoilTempData,
    });
    let isArchive = this?.props?.field_state === 'archive' ? true : false;
    var fieldNameColor = isArchive ? ' text-grey71' : ' text-grey45';
    const showNewPlannerTile = isSupportingPlannerByWeeks(
      this.props.selectedField,
    );
    return (
      <div className='ml-0 ml-lg-3 mr-2'>
        <div className='container-fluid p-0 '>
          <div className='row pb-3 '>
            <div className='col-xl-12 p-0'>
              <div className='font-weight-bold text-size-24 '>
                <div className='d-none d-xl-flex align-items-center '>
                  {isArchive && (
                    <div className='d-inline' style={{ paddingRight: '8px' }}>
                      <img src={ArchiveFieldIcon} />
                    </div>
                  )}
                  {this.props.selectedField && (
                    <div
                      className={'d-inline' + fieldNameColor}
                      style={{ paddingTop: isArchive ? '8px' : '0px' }}
                    >
                      {this.props.selectedField.name}
                    </div>
                  )}
                </div>
                <div className='d-xl-none d-flex'>
                  {isArchive && (
                    <div style={{ paddingRight: '8px' }}>
                      <img src={ArchiveFieldIcon} />
                    </div>
                  )}
                  <FieldsDropdown isArchiveMode={isArchive} />
                </div>
              </div>

              <div className='text-right'>
                <small>
                  {this.props.selectedFarmingUnit &&
                    this.props.selectedFarmingUnit.role === 'admin' &&
                    !isArchive && (
                      <a
                        data-toggle='modal'
                        data-target={'#' + 'fieldModalId'}
                        className='text-grey45 d-xl-none mr-2'
                        data-id={
                          this.props.selectedField
                            ? this.props.selectedField.id
                            : '0'
                        }
                        href='#'
                      >
                        {t('dashboard_edit_field')}
                      </a>
                    )}
                  {this.props.selectedFarmingUnit &&
                    this.props.selectedFarmingUnit.role == 'admin' && (
                      <Link
                        className='mr-1 text-grey45 d-xl-none'
                        to='transmitter-test'
                      >
                        {t('transmitter_admin_page')}
                      </Link>
                    )}

                  <a
                    href='#'
                    className='text-grey45 d-xl-none mr-4'
                    onClick={this.onLogoutButtonClick}
                  >
                    {t('logout')}
                  </a>
                </small>
              </div>
            </div>

            <div className='col-lg-2'></div>
          </div>

          <div className='row' style={{ lineHeight: '40px' }}>
            <div className='col p-0 '>
              <ExtendedFieldDetails />
            </div>
          </div>

          {this.props.field_state === 'archive' && (
            <div
              className='row d-flex bd-highlight flex-wrap'
              style={{
                backgroundColor: '#F6F8FA',
                borderRight: '1px solid #DCE0E8',
                borderLeft: '1px solid #DCE0E8',
              }}
            >
              <div
                className='pt-3 p-3 col-12 '
                style={{ height: '500px', backgroundColor: '#F6F8FA' }}
              >
                {this.graphSwitch(toggleIcons)}
              </div>
            </div>
          )}

          {this.props.field_state === 'active' && (
            <div
              className='d-flex bd-highlight dashboardNextActionsContainerGraphOnly'
              style={{
                backgroundColor: '#F6F8FA',
                borderRight: '1px solid #DCE0E8',
                borderLeft: '1px solid #DCE0E8',
                marginRight: '-15px',
                marginLeft: '-15px',
              }}
            >
              <div
                className='d-flex justify-content-between col-12 flex-grow-1 nextActionsContainerGraphOnly h-100'
                style={{
                  paddingTop: showNewPlannerTile ? '32px' : '34px',
                  minWidth: '430px',
                  maxWidth: '430px',
                }}
              >
                {showNewPlannerTile ? (
                  <RecommendationTileWrapper
                    key={this.props.selectedField.id}
                  />
                ) : null}

                <div className='d-flex flex-column w-100'>
                  <NextActionsContainer
                    selectedField={this.props.selectedField}
                    timezone={
                      this.props.selectedField &&
                      this.props.selectedField.geo_data.time_zone
                    }
                    parentHeight={showNewPlannerTile ? '343px' : '574px'}
                    heigtAuto={true}
                    fieldHasPlan={fieldHasPlan}
                  />
                </div>
              </div>
              <div
                className='p-3 flex-grow-1 '
                style={{
                  height: '660px',
                  // Match the Reported column's paddingTop so the
                  // Water-potential title aligns horizontally with the
                  // Reported header.
                  paddingTop: showNewPlannerTile ? '32px' : '34px',
                  backgroundColor: '#F6F8FA',
                }}
              >
                {this.graphSwitch(toggleIcons)}
              </div>
            </div>
          )}
          <div className='row bg-grey96-three pt-3 pt-md-0'>
            <MapContainer archiveMode={this.props.archiveMode} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  const field = state.distribution_data.selected_entities.field;
  return {
    selectedField: state.distribution_data.selected_entities.field,
    selectedFarmingUnit: state.distribution_data.selected_entities.farming_unit,
    selectedDistribution:
      state.distribution_data.selected_entities.distribution,
    plan_irr: field && field.historical_data && field.historical_data.plan_irr,
    precipitation:
      field && field.historical_data && field.historical_data.precipitation_h,
    loadHistoryStatus: state.distribution_data.field_load_history,
    field_state: state.distribution_data.field_state,
    farming_unit_recommendations:
      state.distribution_data.farming_unit_recommendations.recommendations,
    configuration_data: state.configuration_data,
    temperatureUnit:
      state.authentication_data?.user_data?.temperature || 'celsius',
  };
};

const mapDispatchToProps = {
  setSelectedEntities: distributionActions.selected_entities,
  logout: authenticateActions.logout,
};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(DashboardContent));
